import {makeStyles, styled} from "@material-ui/core/styles";

export const usePackageUpdateCautionStyles = makeStyles((theme) => ({
    dialog: {
        '& .MuiDialog-paper': {
            borderRadius: '4px',
            padding: theme.spacing(2),
            boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
            textAlign: 'center',
            width: 660,
            maxWidth: 700
        },
    },
    title: {
        textAlign: "center",
        marginBottom: theme.spacing(2),
        padding: 0,
        '& .MuiTypography-root.MuiTypography-h6': {
            fontWeight: 'bold !important'
        }
    },
    iconWrapper: {
        display: "flex",
        justifyContent: "center",
        marginBottom: theme.spacing(2),
        '& img': {
            width: '60px'
        }
    },
    contentText: {
        textAlign: "center",
        marginBottom: theme.spacing(2),
    },
    italicText: {
        textAlign: "center",
        fontStyle: "italic",
        color: '#000 !important',
    },
    cancelButton: {
        textTransform: 'capitalize',
        backgroundColor: "#E53935",
        color: "#fff",
        fontWeight: 'bold',
        "&:hover": {
            backgroundColor: "#D32F2F",
        },
    },
    updateCardButton: {
        textTransform: 'capitalize',
        borderColor: '#000 !important',
        fontWeight: 'bold',
        color: '#000 !important',
        '&:focus': {
            backgroundColor: '#fff !important'
        }
    },
    buyNowButton: {
        textTransform: 'capitalize',
        backgroundColor: '#4659FD !important',
        fontWeight: 'bold',
        color: "#fff",
        "&:hover": {
            backgroundColor: '#2a3cdb !important',
        },
    },
    actions: {
        justifyContent: "space-between",
        padding: theme.spacing(2),
    },
    actionButton: {
        display: 'flex',
        alignItems: 'center',
        gap: '20px'
    }
}));

export const useCustomBackdropLoaderStyles = makeStyles(({
    container: {
        width: '100%',
        backgroundColor: '#0000002e',
        height: '200px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        pointerEvents: 'none',
        borderRadius: '7px',
        flexDirection: 'column',
        '& .MuiCircularProgress-root': {
            position: 'unset !important'
        },
        gap: '12px'
    },
    text: {
        color: '#1b0446'
    }
}));

export const useChangeCardModalStyles = makeStyles((theme) => ({
    dialog: {
        '& .MuiDialog-paper': {
            borderRadius: '8px',
            padding: theme.spacing(2),
            minWidth: 700,
            maxWidth: 700,
            height: 380
        },
    },
    contentContainer: {
        display: 'flex',
        flexDirection: 'row',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(2),
    },
    title: {
        fontSize: '1.2rem',
        fontWeight: 'bold',
        color: '#333',
    },
    subtitle: {
        fontSize: '0.85rem',
        color: '#666',
        marginTop: theme.spacing(0.5),
    },
    sidebar: {
        borderRight: '1px solid #eee',
    },
    tabs: {
        '& .MuiTab-root': {
            fontSize: '1rem',
            fontWeight: 600,
            color: '#666',
            textTransform: 'capitalize',
            letterSpacing: '0.3px',
            padding: theme.spacing(1, 2),
            alignItems: 'flex-end',
            textAlign: 'right',
            minHeight: 'auto',

            '&:focus': {
                backgroundColor: 'transparent !important'
            }
        },
        '& .MuiTab-wrapper': {
            display: 'block !important',
        },
        '& .MuiTab-root.Mui-selected': {
            color: '#1976d2',
        },
        '& .MuiTabs-indicator': {
            backgroundColor: '#1976d2',
            width: '2px',
            left: 'auto',
            right: 0,
        },
    },
    highlightedTab: {
        color: '#e91e63 !important',
    },
    headerIcon: {
        width: '50px',
        marginRight: theme.spacing(1),
    },
    tabContent: {
        flex: 1,
        paddingLeft: theme.spacing(2),
        '& label': {
            color: '#000'
        }
    },
    cardNumberField: {
        width: '100%',
        '& .MuiInputBase-input': {
            fontSize: '0.85rem',
            color: '#333',
            padding: `${theme.spacing(1)}px !important`,
            border: 'none !important',
            margin: '0 !important'
        },
        '& .MuiOutlinedInput-root': {
            borderRadius: '6px',
            '& fieldset': {
                borderColor: '#ddd',
            },
            '&:hover fieldset': {
                borderColor: '#ddd',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#ddd',
            },
        },
        '& .MuiInputBase-input.Mui-disabled': {
            color: '#333',
            WebkitTextFillColor: '#333',
        },
    },
    cardEmailField: {
        width: '100%',
        '& .MuiInputBase-input': {
            fontSize: '0.85rem',
            color: '#333',
            padding: `${theme.spacing(1)}px !important`,
            border: 'none !important',
            margin: '0 !important'
        },
        '& .MuiOutlinedInput-root': {
            borderRadius: '6px',
            '& fieldset': {
                borderColor: '#ddd',
            },
            '&:hover fieldset': {
                borderColor: '#ddd',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#ddd',
            },
        },
        '& .MuiInputBase-input.Mui-disabled': {
            color: '#333',
            WebkitTextFillColor: '#333',
        },
        flex: 1
    },
    changeCardButton: {
        backgroundColor: '#4659FD !important',
        color: '#fff',
        textTransform: 'none',
        borderRadius: '7px',
        padding: theme.spacing(0.75, 3),
        fontSize: '0.85rem',
        fontWeight: 'bold',
        '&:hover': {
            backgroundColor: '#2a3cdb !important',
        },
        '&:disabled': {
            opacity: '0.5',
            pointerEvents: 'none'
        }
    },
    cardContainer: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: '15px',
        width: '100%',
        '& .StripeElement': {
            width: '100%',
            border: '1px solid',
            borderRadius: '6px',
            borderColor: 'rgba(0, 0, 0, 0.26)',
            padding: '10.71px 8px',
            flex: 1
        },
        '& label': {
            color: '#000'
        }
    },
    closeButton: {
        fontSize: '0.85rem',
        borderColor: '#000 !important',
        fontWeight: 'bold',
        color: '#000 !important',
        '&:focus': {
            backgroundColor: '#fff !important'
        }
    },
    dialogContent: {
        padding: '8px 6px 8px 8px !important'
    },
    cardNumberList: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        height: '215px',
        overflowY: 'auto',
    },
    cardNumberListElem: {
        display: 'flex',
        alignItems: 'center'
    },
    cardNumberAction: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: '5px',
        '& .MuiButtonBase-root.MuiIconButton-root': {
            padding: '6px',
        }
    },
    cardNumberActionDone: {
        color: 'green'
    },
    cardNumberActionDelete: {
        color: 'red'
    },
    skeletonTabs: {
        width: 150,
        borderRight: '1px solid #eee',
    },
    skeletonContainerActiveCard: {
        display: 'flex',
        flexDirection: 'column',
    },
    skeletonContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px'
    }
}));

export const Wrapper = styled('div')(({ theme}) => ({
    borderRadius: '7px',
    padding: theme.spacing(2),
    boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
    textAlign: 'center',
    backgroundColor: '#fff',
    width: '500px',

    '& .title': {
        textAlign: "center",
        marginBottom: theme.spacing(2),
        color: '#000',
        fontWeight: 600,
        fontSize: '19px'
    },
    '& .iconWrapper': {
        display: "flex",
        justifyContent: "center",
        marginBottom: theme.spacing(2),
        '& img': {
            width: '60px'
        }
    },
    '& .contentText': {
        textAlign: "center",
        marginBottom: theme.spacing(2),
        fontSize: '13px'
    },
    '& .actions': {
        justifyContent: "center",
        padding: theme.spacing(2),
    },
    '& .closeButton': {
        borderColor: theme.palette.text.primary,
        color: theme.palette.text.primary,
        fontWeight: 600,
    },
}));